import { Lightbulb, TrendingUp, Bug, Plug, ChevronRight } from 'lucide-react'
import { WidgetHeader } from './WidgetHeader'

export type FeedbackTypeOption = 'feature' | 'improvement' | 'bug' | 'integration'

interface FeedbackTypeConfig {
  type: FeedbackTypeOption
  icon: React.ElementType
  iconColor: string
  iconBg: string
  label: string
  subtitle: string
}

const FEEDBACK_TYPES: FeedbackTypeConfig[] = [
  {
    type: 'feature',
    icon: Lightbulb,
    iconColor: 'text-blue-500',
    iconBg: 'bg-blue-500/10',
    label: 'Feature request',
    subtitle: 'What would make this better for you?',
  },
  {
    type: 'improvement',
    icon: TrendingUp,
    iconColor: 'text-green-500',
    iconBg: 'bg-green-500/10',
    label: 'Improvement',
    subtitle: 'What should we refine or do differently?',
  },
  {
    type: 'bug',
    icon: Bug,
    iconColor: 'text-red-500',
    iconBg: 'bg-red-500/10',
    label: 'Bug',
    subtitle: 'Something not working as expected?',
  },
  {
    type: 'integration',
    icon: Plug,
    iconColor: 'text-purple-500',
    iconBg: 'bg-purple-500/10',
    label: 'Integration request',
    subtitle: 'Need to connect a tool or service?',
  },
]

interface WidgetFeedbackTypeProps {
  onBack: () => void
  onClose: () => void
  onSelectType: (type: FeedbackTypeOption) => void
}

export function WidgetFeedbackType({ onBack, onClose, onSelectType }: WidgetFeedbackTypeProps) {
  return (
    <div className="flex flex-col h-full">
      <WidgetHeader title="Send Feedback" onBack={onBack} onClose={onClose} />
      <div className="flex-1 overflow-y-auto p-4 space-y-2">
        <p className="text-sm text-muted-foreground mb-3">What kind of feedback do you have?</p>
        {FEEDBACK_TYPES.map((item) => (
          <button
            key={item.type}
            onClick={() => onSelectType(item.type)}
            className="w-full flex items-center gap-3 p-3 rounded-xl border border-border hover:bg-secondary/50 transition-colors text-left group"
          >
            <div className={`w-10 h-10 rounded-lg ${item.iconBg} flex items-center justify-center shrink-0`}>
              <item.icon className={`w-5 h-5 ${item.iconColor}`} />
            </div>
            <div className="flex-1 min-w-0">
              <span className="text-sm font-medium text-foreground block">{item.label}</span>
              <span className="text-xs text-muted-foreground">{item.subtitle}</span>
            </div>
            <ChevronRight className="w-4 h-4 text-muted-foreground shrink-0" />
          </button>
        ))}
      </div>
    </div>
  )
}
